import { Image, Box, Link } from '@chakra-ui/react';
import React from 'react';
import CreatedByEmperia from '../../assets/images/created by emperia.png';
import CreatedByEmperiaAR from '../../assets/images/created by emperia ar.png';
import { Sound } from '../../Icons/Sound';
import { SoundDisabled } from '../../Icons/SoundDisabled';
import { OverlayProps } from '../../interfaces/components';
import { ToEng } from '../../Icons/ToEng';
import { ToArabic } from '../../Icons/ToArabic';
import { Info } from '../../Icons/Info';
import { Wishlist } from '../../Icons/Wishlist';
import { OliveTree } from '../../Icons/OliveTree';
import { GiftCard } from '../../Icons/GiftCard';
import { Ribbon } from '../../Icons/Ribbon';
import { GiftBox } from '../../Icons/GiftBox';
import Toast from './Toast';
import { CollectInfo } from '../../Icons/CollectInfo';
import { dispatchCTAClickObject } from '../../Analytics';

const Overlay = ({
  collectibletToastActive,
  wishlistToastActive,
  wishlistToastText,
  collectedItems,
  audioActive,
  activeLocale,
  toggleInstructions,
  toggleAudio,
  setLocale,
  setCollectibletToastActive,
  setWishlistToastActive,
  openWishlist,
  openReward,
}: OverlayProps) => {
  return (
    <Box className="layout">
      <Toast
        activeLocale={activeLocale}
        position="absolute"
        active={wishlistToastActive}
        text={wishlistToastText}
        setActive={(state: boolean) => setWishlistToastActive(state)}
      />

      {/* Right Top Floating Buttons */}
      <Box
        position="fixed"
        height={['230px', '230px', '250px', '250px', '250px']}
        top={['15px', '20px', '25px']}
        right={['15px', '20px', '25px']}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexDirection="column"
        zIndex={6}
      >
        <Info
          marginLeft="auto"
          boxSize={[9, 9, 10, 10]}
          cursor="pointer"
          borderRadius="100%"
          fill="#FDC506"
          _hover={{
            fill: '#F9DD7D',
          }}
          transition="0.5s"
          onClick={() => toggleInstructions()}
        />
        {audioActive ? (
          <Sound
            marginLeft="auto"
            boxSize={[9, 9, 10, 10]}
            cursor="pointer"
            borderRadius="100%"
            fill="#FDC506"
            _hover={{
              fill: '#F9DD7D',
            }}
            transition="0.5s"
            onClick={toggleAudio}
          />
        ) : (
          <SoundDisabled
            marginLeft="auto"
            boxSize={[9, 9, 10, 10]}
            cursor="pointer"
            borderRadius="100%"
            fill="#FDC506"
            _hover={{
              fill: '#F9DD7D',
            }}
            transition="0.5s"
            onClick={toggleAudio}
          />
        )}

        <Wishlist
          marginLeft="auto"
          boxSize={[9, 9, 10, 10]}
          cursor="pointer"
          borderRadius="100%"
          fill="#FDC506"
          _hover={{
            fill: '#F9DD7D',
          }}
          transition="0.5s"
          onClick={() => openWishlist()}
        />

        <OliveTree
          marginLeft="auto"
          boxSize={[9, 9, 10, 10]}
          cursor="pointer"
          borderRadius="100%"
          fill="#FDC506"
          _hover={{
            fill: '#F9DD7D',
          }}
          transition="0.5s"
          onClick={() => {
            window.GotoScene('loccitane_35');
            dispatchCTAClickObject('loccitane', 'button', 'oliveTree', 'teleport', '');
          }}
        />
        {activeLocale === 'ar' ? (
          <ToEng
            marginLeft="auto"
            boxSize={[9, 9, 10, 10]}
            cursor="pointer"
            borderRadius="100%"
            fill="#FDC506"
            _hover={{
              fill: '#F9DD7D',
            }}
            transition="0.5s"
            onClick={() => setLocale('en')}
          />
        ) : (
          <ToArabic
            marginLeft="auto"
            boxSize={[9, 9, 10, 10]}
            cursor="pointer"
            borderRadius="100%"
            fill="#FDC506"
            _hover={{
              fill: '#F9DD7D',
            }}
            transition="0.5s"
            onClick={() => setLocale('ar')}
          />
        )}
      </Box>

      {/* Right Bottom Floating Buttons */}
      <Box
        position="fixed"
        bottom={['15px', '20px', '25px']}
        left={['15px', '20px', '25px']}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        zIndex={6}
      >
        <Box
          height={['190px']}
          p={['20px 10px']}
          borderRadius="30px"
          backgroundColor="#FFFFFFCC"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexDirection="column"
        >
          <GiftCard
            boxSize={[7, 7, 7, 7]}
            cursor="pointer"
            transition="0.5s"
            fill={collectedItems.giftcard ? '#FFCB00' : 'white'}
            onClick={openReward}
          />
          <Ribbon
            boxSize={[7, 7, 7, 7]}
            cursor="pointer"
            transition="0.5s"
            fill={collectedItems.ribbon ? '#FFCB00' : 'white'}
            onClick={openReward}
          />
          <GiftBox
            boxSize={[7, 7, 7, 7]}
            cursor="pointer"
            transition="0.5s"
            fill={collectedItems.giftbox ? '#FFCB00' : 'white'}
            onClick={openReward}
          />
          <CollectInfo boxSize={[7, 7, 7, 7]} cursor="pointer" onClick={openReward} />
        </Box>
      </Box>

      <Toast
        activeLocale={activeLocale}
        position="absolute"
        active={collectibletToastActive}
        text={activeLocale.includes('ar') ? 'تم جمع المنتج' : 'Item Collected'}
        setActive={(state: boolean) => setCollectibletToastActive(state)}
      />

      {/* Created By Emperia Link */}
      <Link href="https://emperiavr.com/" target="_blank">
        <Box position="fixed" bottom={['15px', '20px', '25px']} right={['15px', '20px', '25px']} cursor="pointer">
          <Image
            loading="lazy"
            src={activeLocale === 'ar' ? CreatedByEmperiaAR : CreatedByEmperia}
            width={['150px', '150px', '200px', '200px', '200px', '200px']}
          />
        </Box>
      </Link>
    </Box>
  );
};

export default Overlay;
